<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li
                v-if="$app.canAdministrate"
                class="breadcrumb-item"
            >
                <router-link to="/admin">
                    Admin
                </router-link>
            </li>

            <slot />
        </ol>
    </nav>
</template>

<script>
export default {
    name: "AdminBreadcrumbs",
};
</script>
